module.exports = __webpack_public_path__ + "img/sber.c4489936.jpg";